import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from './../../../private/shared/modules/shared.module';
import { OrderProgressPage } from './order-progress.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    SharedModule,
  ],
  declarations: [OrderProgressPage]
})
export class OrderProgressPageModule { }
